module.exports = __webpack_public_path__ + "img/ja.60d950b2.png";